import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: () => import('@/page/home/index'),
      meta: {
        title: '企业会员-企业内训视频-定制培训服务-东方瑞通'
      }
    },
    {
      path: '/home-index',
      redirect: '/'
    },
    // {
    //   path: '/dh',
    //   name: 'Index',
    //   component: () => import('@/page/index'),
    //   meta: {
    //     title: '企业会员-企业内训视频-定制培训服务-东方瑞通'
    //   }
    // },
    {
      path: '/home-step1',
      name: 'home-step1',
      component: () => import('@/page/home/step1'),
      meta: {
        title: '企业会员申请第一步-东方瑞通'
      }
    }, {
      path: '/home-step2',
      name: 'home-step2',
      component: () => import('@/page/home/step2'),
      meta: {
        title: '企业会员申请第二步-东方瑞通'
      }
    }, {
      path: '/home-step3',
      name: 'home-step3',
      component: () => import('@/page/home/step3'),
      meta: {
        title: '企业会员申请第三步-东方瑞通'
      }
    }, {
      path: '/contact-index',
      name: 'contact-index',
      component: () => import('@/page/contact/index')
    }, {
      path: '/contact-buy-video',
      name: 'contact-buy-video',
      component: () => import('@/page/contact/buyVideo')
    }, {
      path: '/contact-buy-video-confirm',
      name: 'contact-buy-video-confirm',
      component: () => import('@/page/contact/buyVideoConfirm')
    }, {
      path: '/contact-buy-activity-list',
      name: 'contact-buy-activity-list',
      component: () => import('@/page/contact/buyActivityList')
    }, {
      path: '/contact-buy-activity-confirm',
      name: 'contact-buy-activity-confirm',
      component: () => import('@/page/contact/buyActivityConfirm')
    }, {
      path: '/contact-colleague-list',
      name: 'contact-colleague-list',
      component: () => import('@/page/contact/colleagueList')
    }, {
      path: '/contact-add-colleague',
      name: 'contact-add-colleague',
      component: () => import('@/page/contact/addColleague')
    }, {
      path: '/contact-view-video-list',
      name: 'contact-view-video-list',
      component: () => import('@/page/contact/viewVideoList')
    }, {
      path: '/major-view-video-list',
      name: 'major-view-video-list',
      component: () => import('@/page/contact/majorVideoList')
    }, {
      path: '/contact-view-account',
      name: 'contact-view-account',
      component: () => import('@/page/contact/viewAccount')
    }, {
      path: '/contact-change-contact',
      name: 'contact-change-contact',
      component: () => import('@/page/contact/changeContact')
    }, {
      path: '/contact-change-contact-info',
      name: 'contact-change-contact-info',
      component: () => import('@/page/contact/changeContactInfo')
    },
    // {
    //   path: '/student-index',
    //   name: 'student-index',
    //   component: () => import('@/page/student/index')
    // },
    {
      path: '/student-video-list',
      name: 'student-video-list',
      component: () => import('@/page/student/videoList')
    },
    // {
    //   path: '/student-video-play',
    //   name: 'student-video-play',
    //   component: () => import('@/page/student/videoPlay')
    // },
    {
      path: '/student-notice-centre-list',
      name: 'student-notice-centre-list',
      component: () => import('@/page/student/noticeCentreList')
    }, {
      path: '/student-change-contact',
      name: 'student-change-contact',
      component: () => import('@/page/student/changeContact')
    }, {
      path: '/student-link-company',
      name: 'student-link-company',
      component: () => import('@/page/student/linkCompany')
    }, {
      path: '/activationCode',
      name: 'activationCode',
      component: () => import('@/page/public/activationCode')
    }, {
      path: '/home-result',
      name: 'result',
      component: () => import('@/page/home/result')
    }, {
      path: '/play-video',
      name: 'result',
      component: () => import('@/page/public/video')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js